export const DATEFORMAT = {
    // most of the commun format date add accordingly
    EMPTY :'',
    YY:'YY',
    YYYY:'YYYY',
    M:'M',
    MM:'MM',
    MMM:'MMM',
    MMMM:'MMMM',
    YYYY_MM_DD:'YYYY-MM-DD',
    YYYY_M_D:'YYYY-M-D',
    DD_MM_YYYY:'DD/MM/YYYY',
    // localized formats
    LT:'LT',
    LTS:'LTS',
    L:'L',
    LL:'LL',
    LLL:'LLL',
    LLLL:'LLLL',
    l:'l',
    ll:'ll',
    lll:'lll',
    llll:'llll'
}

// units use to set the diff value
export const DIFFUNITS = {
    YEAR:'y',
    MONTH: 'M',
    WEEK:'w',
    DAY:'d',
    HOUR:'h',
    MINUTE:'m',
    SECOND:'s',
    MILLISECOND:'ms',
    QUARTER:'Q'
}